/** Application colour themes. */
export type Theme = 'dark' | 'light';

export const THEMES: readonly Theme[] = ['dark', 'light'];

/** Theme used when the user has not chosen one. */
export const DEFAULT_THEME: Theme = 'dark';

export function isTheme(value: unknown): value is Theme {
  return typeof value === 'string' && (THEMES as readonly string[]).includes(value);
}
